import {
  service_ResponseForNonMemberPortalOfficeHospitalListing,
  ibow2_proto_PortalOfficeHospitalListing,
} from '@/init/swagger';
import * as v from 'valibot';

const HospitalListingSchema = v.object({
  id: v.fallback(v.number(), 0),
  director_name: v.fallback(v.string(), ''),
  latitude: v.fallback(v.number(), 0),
  longitude: v.fallback(v.number(), 0),
  official_hp_url: v.fallback(v.string(), ''),
  portal_office: v.object({
    area: v.fallback(v.string(), ''),
    building: v.fallback(v.string(), ''),
    city: v.fallback(v.string(), ''),
    fax_area: v.fallback(v.string(), ''),
    fax_city: v.fallback(v.string(), ''),
    fax_num: v.fallback(v.string(), ''),
    ibow_office_id: v.fallback(v.number(), 0),
    id: v.fallback(v.number(), 0),
    is_carelogood: v.fallback(v.boolean(), false),
    listing_released_at: v.fallback(v.string(), ''),
    listing_updated_at: v.fallback(v.string(), ''),
    medical_institution_code: v.fallback(v.string(), ''),
    name: v.fallback(v.string(), ''),
    office_code: v.fallback(v.string(), ''),
    post_code: v.fallback(v.string(), ''),
    pref: v.fallback(v.number(), 0),
    tel_area: v.fallback(v.string(), ''),
    tel_city: v.fallback(v.string(), ''),
    tel_num: v.fallback(v.string(), ''),
  }),
  portal_office_hospital_listing_business_hour: v.optional(
    v.nullable(
      v.object({
        friday_business_hour: v.fallback(v.string(), '-'),
        holiday_business_hour: v.fallback(v.string(), '-'),
        id: v.fallback(v.number(), 0),
        is_holiday_friday: v.fallback(v.boolean(), false),
        is_holiday_holiday: v.fallback(v.boolean(), false),
        is_holiday_monday: v.fallback(v.boolean(), false),
        is_holiday_saturday: v.fallback(v.boolean(), false),
        is_holiday_sunday: v.fallback(v.boolean(), false),
        is_holiday_thursday: v.fallback(v.boolean(), false),
        is_holiday_tuesday: v.fallback(v.boolean(), false),
        is_holiday_wednesday: v.fallback(v.boolean(), false),
        monday_business_hour: v.fallback(v.string(), '-'),
        portal_office_hospital_listing_id: v.fallback(v.number(), 0),
        saturday_business_hour: v.fallback(v.string(), '-'),
        sunday_business_hour: v.fallback(v.string(), '-'),
        thursday_business_hour: v.fallback(v.string(), '-'),
        tuesday_business_hour: v.fallback(v.string(), '-'),
        wednesday_business_hour: v.fallback(v.string(), '-'),
      }),
    ),
  ),
  portal_office_hospital_listing_doctor_specialties: v.fallback(
    v.array(
      v.object({
        doctor_specialty_id: v.fallback(v.number(), 0),
        id: v.fallback(v.number(), 0),
        portal_office_hospital_listing_id: v.fallback(v.number(), 0),
      }),
    ),
    [],
  ),
  portal_office_hospital_listing_image: v.optional(
    v.fallback(
      v.object({
        id: v.fallback(v.number(), 0),
        image1: v.fallback(v.string(), ''),
        image1_url: v.fallback(v.string(), ''),
        image2: v.fallback(v.string(), ''),
        image2_url: v.fallback(v.string(), ''),
        image3: v.fallback(v.string(), ''),
        image3_url: v.fallback(v.string(), ''),
        image4: v.fallback(v.string(), ''),
        image4_url: v.fallback(v.string(), ''),
        image5: v.fallback(v.string(), ''),
        image5_url: v.fallback(v.string(), ''),
      }),
      {
        id: 0,
        image1: '',
        image1_url: '',
        image2: '',
        image2_url: '',
        image3: '',
        image3_url: '',
        image4: '',
        image4_url: '',
        image5: '',
        image5_url: '',
      },
    ),
  ),
  portal_office_hospital_listing_medical_subjects: v.fallback(
    v.array(
      v.object({
        medical_subject_id: v.fallback(v.number(), 0),
        name: v.fallback(v.string(), ''),
      }),
    ),
    [],
  ),
  portal_office_hospital_listing_services: v.fallback(
    v.array(
      v.object({
        id: v.fallback(v.number(), 0),
        portal_office_hospital_listing_id: v.fallback(v.number(), 0),
        category_id: v.fallback(v.number(), 0),
        search_filter_id: v.fallback(v.number(), 0),
      }),
    ),
    [],
  ),
  portal_office_id: v.fallback(v.number(), 0),
  published_at: v.fallback(v.string(), ''),
  request_status: v.fallback(v.number(), 0),
  request_user_favorite: v.optional(
    v.nullable(
      v.object({
        id: v.fallback(v.number(), 0),
        user_id: v.fallback(v.number(), 0),
      }),
    ),
  ),
});

export type HospitalListingInput = v.InferInput<typeof HospitalListingSchema>;
export type HospitalListingOutput = v.InferOutput<typeof HospitalListingSchema>;

export const asHospitalListing = (
  hospitalListing:
    | service_ResponseForNonMemberPortalOfficeHospitalListing
    | ibow2_proto_PortalOfficeHospitalListing,
): HospitalListingOutput => {
  return v.parse(HospitalListingSchema, hospitalListing);
};

export const parseHospitalListings = (
  hospitalListings: Array<
    | service_ResponseForNonMemberPortalOfficeHospitalListing
    | ibow2_proto_PortalOfficeHospitalListing
  >,
): HospitalListingOutput[] => {
  return hospitalListings.map((listing) => asHospitalListing(listing));
};
